import type {VerticalGroup} from '../../models/vertical-group'

export function normalizeGroupName(group: VerticalGroup) {
  return group.name.toLocaleLowerCase().trim()
}
